import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_1: FaireProductEntity = {
  token: "atc_updated_moma_1",
  type: "product",
  name: "I ❤️ NY Coffee Cup",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/306fba99bb5b93fe43cbf5a311ec9eab3967ef6fa16edb01991ea615cd8d5aad.webp",
  priceDollars: 18,
  msrpDollars: 22,
  description: "White ceramic cup with I ❤️ NY print.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
